import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { createColumnHelper } from "@tanstack/react-table";
import moment from "moment-timezone";
import { StatusCell } from "../Certifications/useColumns";
import { renderSettingsResourceLabel } from "../../../../utils/helpers/settings";
import { useCompanyDateFormat } from "../../../../utils/hooks/company";

const columnHelper = createColumnHelper();

export const useColumns = ({ edit, remove }) => {
    const { t } = useTranslation();
    const dateFormat = useCompanyDateFormat();

    return useMemo(() => {
        const columns = [
            columnHelper.accessor("type", {
                header: t("type"),
                cell: (info) => {
                    return renderSettingsResourceLabel(info.getValue());
                },
            }),
            columnHelper.accessor("startDate", {
                header: t("start-date"),
                cell: (info) => {
                    const value = info.getValue();
                    return value ? moment(value).format(dateFormat) : null;
                },
            }),
            columnHelper.accessor("endDate", {
                header: t("end-date"),
                cell: (info) => {
                    const value = info.getValue();
                    return value ? moment(value).format(dateFormat) : null;
                },
            }),
            columnHelper.accessor("state", {
                header: t("state"),
                cell: (info) => {
                    return info.getValue();
                },
            }),
            columnHelper.accessor("status", {
                header: t("status"),
                cell: (info) => {
                    const value = info.getValue();
                    return <StatusCell value={value} />
                },
            }),
        ];
        const actionColumn = columnHelper.display({
            id: "actions",
            enableHiding: false,
            enableColumnFilter: false,
            header: <div className="text-right">{t("actions")}</div>,
            cell: (info) => {
                const row = info.row.original;
                return (
                    <div className="actions text-primary text-right">
                        {(edit && row.status !== "expired") && (
                            <span
                                className="btn-inner--icon mr-3 icon-sm cursor-pointer"
                                onClick={() => edit(row)}
                                style={{ cursor: "pointer" }}
                            >
                                <i className="fas fa-pen" />
                            </span>
                        )}

                        {remove && (
                            <span
                                className="btn-inner--icon mr-3 icon-sm cursor-pointer"
                                onClick={() => remove(row.id)}
                                style={{ cursor: "pointer" }}
                            >
                                <i className="fas fa-trash" />
                            </span>
                        )}
                    </div>
                );
            },
        });
        columns.push(actionColumn);
        return columns;
    }, [dateFormat, edit, remove, t]);
};
